import React from 'react';
import { FaPersonWalkingLuggage } from 'react-icons/fa6';
import {Link, Outlet} from 'react-router-dom'
import STC from '../../../STCLibrary/STCFactory/STCFactory';

export default function Leader(){
    
    const handleOpenInsurance = () => {
        window.open('https://www.accidentgeneral.ie/stc', "_blank");
    }


    return(
        <div>
            <div className="page-header">
                <STC.Alert variant='danger' onClick={handleOpenInsurance}>
                    <div><strong>STC Insurance Resources:</strong></div>
                    <div>Click here to find your standard policy documents, webinar links, and other useful information on this page.</div>
                </STC.Alert>
            </div>
            <div className="page-header">
                <h1>
                    <FaPersonWalkingLuggage /> <span>Tours</span>
                </h1>
            </div>
            <Outlet/>
        </div>
    )
}